import { gql } from '@apollo/client'

export const AGGREGATE_INSIGHT_FRAGMENT = gql`
  fragment AggregateInsight on AggregateInsight {
    message
    insightType
    sentiment
    storeIds
  }
`
